<template>
	<div>
		<canvas id="canvas" width="950" height="550" class="graphic"></canvas>
	</div>
</template>
<script>
/* eslint-disable func-names */
/* eslint-disable no-param-reassign */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
/* eslint-disable arrow-parens */
/* eslint-disable no-confusing-arrow */
/* eslint-disable no-undef */
/* eslint-disable indent */
/* eslint-disable comma-spacing */
/* eslint-disable no-underscore */
/* eslint-disable no-plusplus */
/* eslint-disable no-trailing-spaces */
/* eslint-disable no-underscore-dangle */
/* eslint-disable space-infix-ops */
/* eslint-disable semi */
/* eslint-disable eqeqeq */
/* eslint-disable no-new */
/* eslint-disable prefer-const */
/* eslint-disable no-mixed-spaces-and-tabs */
const properties = {
	textSize: 12,
	color1: '#246ef5',
	color2: '#8FE84D',
	grayZoneColor: '#F1B15A',
	brechaColor: '#C33825',
}

class RadarChart {
	static get LINES_PER_AREAS() {
		return 5;
	}

	static get STROKE_WIDTH() {
		return 0.3;
	}

	static get LINES_BACKGROUND_COLOR() {
		return '#333333';
	}

	static get TEXT_COLOR() {
		return '#444444';
	}

	static get PADDING() {
		return 40;
	}

	static get DOT_SIZE() {
		return 5;
	}

	get TOTAL_AREAS() {
		return this.data.maxValue;
	}

	get TEXT_SIZE() {
		return this.properties.textSize || 10;
	}

	get LINE_COLOR_1() {
		return this.properties.color1 || '#0000aa';
	}

	get LINE_COLOR_2() {
		return this.properties.color2 || '#00aa00';
	}

	get GRAY_ZONE_COLOR() {
		return this.properties.grayZoneColor || '#aaed99';
	}

	get BRECHA_COLOR() {
		return this.properties.brechaColor || '#881111';
	}

/**
 * Creacion de objeto Grafico
 @param {canvas} canvas
 @param {object} data
 @param {object} properties
 */
	constructor(canvas, data, properties = {}) {
		this.canvas = canvas;
		this.context = canvas.getContext('2d');
		this.data = data;
		this._canvasWidth = this.canvas.width;
		this._canvasHeight = this.canvas.height;
		this.properties = properties;
		this.initCanvas();
		this.draw();
	}

	get itemCount() {
		return this.data.values ? this.data.values.length : 0;
	}

	get canvasWidth() {
		return this._canvasWidth;
	}

	get canvasHeight() {
		return this._canvasHeight;
	}

	get maxRadius() {
		const maxSize = Math.min(this.canvasWidth, this.canvasHeight) / 2;
		return maxSize - RadarChart.PADDING * 2;
	}

	get rotation() {
		if (this.itemCount % 2) {
			return -1.5 * Math.PI / this.itemCount;
		}
		return Math.PI / this.itemCount;
	}

	initCanvas() {
		// Get the device pixel ratio, falling back to 1.
		const dpr = window.devicePixelRatio || 1;
		// Get the size of the canvas in CSS pixels.
		const rect = this.canvas.getBoundingClientRect();
		// Give the canvas pixel dimensions of their CSS
		// size * the device pixel ratio.
		this.canvas.width = rect.width * dpr;
		this.canvas.height = rect.height * dpr;
		
		this.canvas.style.width = this.canvasWidth;
		this.canvas.style.height = this.canvasHeight;
		// Scale all drawing operations by the dpr, so you
		// don't have to worry about the difference.
		this.context.scale(dpr, dpr);
		// Center in 0,0
		this.context.translate(this.canvasWidth / 2, this.canvasHeight / 2);
	}

	drawBackgroundLines() {
	const space = this.maxRadius / (this.TOTAL_AREAS * RadarChart.LINES_PER_AREAS);
		let radius = space;
		this.context.lineWidth = RadarChart.STROKE_WIDTH;
		this.context.strokeStyle = RadarChart.LINES_BACKGROUND_COLOR;
		for (let i = 0; i < this.TOTAL_AREAS * RadarChart.LINES_PER_AREAS; i++) {
			if ((i + 1) % RadarChart.LINES_PER_AREAS == 0) {
					this.context.globalAlpha = 1;
			} else {
					this.context.globalAlpha = 0.4;
			}
			this.context.beginPath();
				
			for (let j = 0; j < this.itemCount; j++) {
				const rad = j * 2 * Math.PI / this.itemCount;
				const x = Math.cos(rad) * radius;
				const y = Math.sin(rad) * radius;
				if (j == 0) {
					this.context.moveTo(x, y);
				} else {
					this.context.lineTo(x, y);
				}
			}
				this.context.closePath();
				this.context.stroke();
				radius += space;
		}
  }

	drawGrayZone() {
		if (!this.data.greyZone) {
			return;
		}
		const max = this.data.greyZone.max / this.data.maxValue * this.maxRadius;
		const min = this.data.greyZone.min / this.data.maxValue * this.maxRadius;

		this.context.globalAlpha = 0.25;
		this.context.fillStyle = this.GRAY_ZONE_COLOR;
		this.context.beginPath()
		this.context.arc(0,0,max,0,Math.PI*2, false); // outer (filled)
		this.context.arc(0,0,min,0,Math.PI*2, true); // outer (unfills it)
		this.context.fill();
		this.context.globalAlpha = 1;
	}

	drawPoints() {
		const _this = this;
		this.context.font = `bold ${this.TEXT_SIZE}px Arial`;
		function drawDots(x, y, value, rad, outer, color) {
			_this.context.save();
			// Draw Dot
			_this.context.fillStyle = color;
			_this.context.beginPath();
			_this.context.translate(x, y);
			_this.context.arc(0, 0, RadarChart.DOT_SIZE, 0 ,Math.PI * 2, true); // outer (filled)
			_this.context.fill();

			const distance = Math.sqrt(y * y + x * x);
			const u1 = x / distance;
			const v1 = y / distance;
			// Draw Text Dot
			if (outer) {
				_this.context.translate(u1 * 12, v1 * 12);
			} else {
				_this.context.translate(u1 * -14, v1 * -14);
			}
			_this.context.rotate(-_this.rotation);
			const xRot = Math.cos(rad + _this.rotation) * _this.maxRadius;
			if (outer) {
				if (xRot > 30) {
						_this.context.textAlign = 'left';
				} else if (xRot < -30) {
						_this.context.textAlign = 'right';
				} else {
						_this.context.textAlign = 'center';
				}
			} else if (xRot > 220) {
					_this.context.textAlign = 'right';
			} else if (xRot < -220) {
					_this.context.textAlign = 'left';
			} else {
					_this.context.textAlign = 'center';
			}
			_this.context.textBaseline = 'middle';
			_this.context.fillStyle = RadarChart.TEXT_COLOR;
			_this.context.fillText(`${value.toFixed(2)}`, 0, 0);

			_this.context.restore();
		}
		this.data.values.forEach((value, index) => {
			const v1 = value.v1;
			const v2 = value.v2;
			const rad = index * 2 * Math.PI / this.itemCount;
			const max1 = v1 / this.data.maxValue * this.maxRadius;
			const max2 = v2 / this.data.maxValue * this.maxRadius;
			const x1 = Math.cos(rad) * max1;
			const y1 = Math.sin(rad) * max1;
			const x2 = Math.cos(rad) * max2;
			const y2 = Math.sin(rad) * max2;
			// drawDots(x1, y1, v1, rad, max1 > max2, this.LINE_COLOR_1); draw line blue
			drawDots(x2, y2, v2, rad, max2 > max1, this.LINE_COLOR_2);
		})
	}

  drawDataLine() {
		const _this = this;
		function drawLines(values, color) {
			_this.context.beginPath();
			values.forEach((value, index) => {
				const rad = index * 2 * Math.PI / _this.itemCount;
				const distance = value / _this.data.maxValue * _this.maxRadius;
				_this.context.strokeStyle = color;
				_this.context.lineWidth = RadarChart.STROKE_WIDTH * 10;
				const x = Math.cos(rad) * distance;
				const y = Math.sin(rad) * distance;
				if (index === 0) {
					_this.context.moveTo(x, y);
				} else {
					_this.context.lineTo(x, y);
				}
			});
			_this.context.closePath();
			_this.context.stroke();
		}
		const values2 = this.data.values.map((e) => e.v2);
		const values1 = this.data.values.map((e) => e.v1);
		drawLines(values1, this.LINE_COLOR_1);
		drawLines(values2, this.LINE_COLOR_2);
	}
	 
	drawText() {
		this.context.fillStyle = RadarChart.TEXT_COLOR;
		const maxRadius = this.maxRadius;
		const itemCount = this.itemCount;
		let rotation = this.rotation;
		const step = maxRadius / this.TOTAL_AREAS;
		this.context.font = `${this.TEXT_SIZE}px Arial`;
		// DRAW LOCATION NUMBER TEXT
		for (let i = 0; i < this.TOTAL_AREAS + 1; i++) {
			const rad = (this.itemCount - 1) * 2 * Math.PI / itemCount;
			const x = Math.cos(rad) * step * i;
			const y = Math.sin(rad) * step * i;
			this.context.save();
			this.context.translate(x - 15, y - 10);
			this.context.rotate(-rotation);
			this.context.fillText(i, 0, 0);
			this.context.restore();
		}
			// DRAW NAME DATA ITEMS
		this.context.font = `bold ${this.TEXT_SIZE}px Arial`;
		this.data.values.forEach((e, index) => {
			this.context.save();
			const name = e.name;
			const rad = index * 2 * Math.PI / itemCount;
			const x = Math.cos(rad) * (maxRadius + RadarChart.PADDING);
			const y = Math.sin(rad) * (maxRadius + RadarChart.PADDING);
			this.context.translate(x, y);
			this.context.rotate(-rotation);
			const xRot = Math.cos(rad + rotation) * maxRadius;
			if (xRot > 30) {
				this.context.textAlign = 'left';
			} else if (xRot < -30) {
				this.context.textAlign = 'right';
			} else {
				this.context.textAlign = 'center';
			}
			this.context.fillStyle = e.color;
			// this.context.fillText(name, 0, 0);
			// this.context.restore();
			const maxLength = 25;
			let lines = [];
			if (name.length > maxLength) {
				let currentLine = '';
				const words = name.split(' ');
				words.forEach((word, i) => {
					if (currentLine.length + word.length <= maxLength) {
						currentLine += `${word} `;
					} else {
						lines.push(currentLine.trim());
						currentLine = `${word} `;
					}
					if (i === words.length - 1) {
						lines.push(currentLine.trim());
					}
				});
			} else {
				lines.push(name);
			}

			lines.forEach((line, j) => {
				this.context.fillText(line, 0, j * 20);
			});

			this.context.restore();
		});
	}

	drawBrecha() {
		const _this = this;
		this.context.strokeStyle = this.BRECHA_COLOR;
		this.context.fillStyle = this.BRECHA_COLOR;
		this.context.lineWidth = RadarChart.STROKE_WIDTH * 5;
		function drawArrow(x1, y1, x2, y2) {
			_this.context.save();
			_this.context.translate(x1, y1);
			_this.context.rotate(Math.atan2(y1 - y2, x1 - x2) + Math.PI / 2);
			_this.context.beginPath();
			_this.context.moveTo(0, 0);
			_this.context.lineTo(-5, 8);
			_this.context.lineTo(5, 8);
			_this.context.fill();
			_this.context.restore();
		}
		this.data.values.forEach((value, index) => {
			const brecha = value.brecha || _this.data.brecha;
			if (Math.abs(value.v1 - value.v2) > brecha) {
					// Dibujar brecha
				const rad = index * 2 * Math.PI / _this.itemCount;
				const max1 = value.v1 / _this.data.maxValue * _this.maxRadius;
				const max2 = value.v2 / _this.data.maxValue * _this.maxRadius;
				const x1 = Math.cos(rad) * (max1 + (max1 < max2 ? 10 : -10));
				const y1 = Math.sin(rad) * (max1 + (max1 < max2 ? 10 : -10));
				const x2 = Math.cos(rad) * (max2 + (max1 > max2 ? 10 : -10));
				const y2 = Math.sin(rad) * (max2 + (max1 > max2 ? 10 : -10));
				_this.context.beginPath();
				_this.context.moveTo(x1, y1);
				_this.context.lineTo(x2, y2);
				_this.context.stroke();
				// Draw Arrow end
				drawArrow(x1, y1, x2, y2);
				drawArrow(x2, y2, x1, y1);
			}
		});
	}

	draw() {
		this.context.save();
		this.context.rotate(this.rotation);
		// Dibujar las lineas de fondo
		this.drawBackgroundLines();
		// Dibujar la zona "gris"
		this.drawGrayZone();
		// Dibujar las lineas de datos
		this.drawDataLine();
		this.drawPoints();
		this.drawBrecha();
		// Draw Text
		this.drawText();
		this.context.restore();
	}
}

/**
 * Instanciacion de grafico
 */

function drawChart(data) {
	// Historical delay: keeps fonts/layout ready before drawing on the canvas.
	setTimeout(() => {
		try {
			const canvas = this.$el.querySelector('canvas');
			new RadarChart(canvas, data, properties);
			// Notify parents exactly when the canvas has content, so they can
			// capture it instead of relying on fixed-time waits.
			this.$emit('drawn');
		} catch (error) {
			console.error('[graphic] RadarChart:', error);
			this.showGenericError('ERROR EN GRÁFICO');
			this.$emit('drawn-error', error);
		}
	}, 2000);
}

function mounted() {
	this.drawChart(this.data);
}

function data() {
	return {
		// properties: {
		// 	textSize: 10,
		// 	color1: '#0000aa',
		// 	color2: '#00aa00',
		// 	grayZoneColor: '#aa2299',
		// 	brechaColor: '#881111',
		// },
	};
}

export default {
	name: 'graphic',
	data,
	mounted,
	props: {
		data: {
			type: Object,
			default: () => {},
		},
	},
	methods: {
		drawChart,
	},
	watch: {
		data: {
			handler(newVal) {
				this.drawChart(newVal);
			},
		},
	},
};
</script>
<style lang="scss" scoped>
	.graphic {
		@media print {
			height: 460px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/shared/charts/graphic.vue